import React from "react";

const DeleteForm = () => {
  return (
    <div>
      <h4>Are you sure you want to delete this opportunity</h4>
    </div>
  )
}

export default DeleteForm;
